import React, { useState } from 'react';

const RegistrationForm = ({ selectedSeats, onSubmitRegistration, onBack }) => {
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name.trim() || !phone.trim()) {
      alert('Please enter both name and phone number.');
      return;
    }
    // Basic phone validation (you might want a more robust one)
    if (!/^\+?[0-9\s-]{7,15}$/.test(phone)) {
        alert('Please enter a valid phone number.');
        return;
    }
    
    setIsSubmitting(true);
    try {
      await onSubmitRegistration({ name, phone, seats: selectedSeats });
    } catch (error) {
      console.error('Registration failed:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="registration-form">
      <button className="back-btn" onClick={onBack}>&larr; Back</button>
      <h2>Đăng ký thông tin</h2>
      <div className="booking-summary">
        <p><strong>Ghế đã chọn:</strong></p>
        <div className="seat-summary">
          {selectedSeats.map(seatId => (
            <div key={seatId} className="seat-summary-item">
              <span className="seat-id">Seat {seatId}</span>
            </div>
          ))}
        </div>
      </div>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="name">Họ và tên:</label>
          <input
            type="text"
            id="name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Nhập họ và tên"
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="phone">Số điện thoại:</label>
          <input
            type="tel"
            id="phone"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            placeholder="Nhập số điện thoại"
            required
          />
        </div>
        <button 
          type="submit" 
          className="submit-btn btn btn-primary btn-lg"
          disabled={isSubmitting}
        >
          {isSubmitting ? (
            <div className="loading-container">
              <div className="loading-spinner"></div>
              <span>Đang xử lý...</span>
            </div>
          ) : (
            'Xác nhận đặt vé'
          )}
        </button>
      </form>
    </div>
  );
};

export default RegistrationForm;
